import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';

function ForgotPassword() {
  const navigate = useNavigate();
  const [method, setMethod] = useState('email');
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!identifier.trim()) {
      setError(`Please enter your ${method}`);
      return;
    }

    navigate('/verify-otp', {
      state: {
        flow: 'forgot-password',
        identifier,
        method,
      },
    });
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Brand />
        <Link to="/login" className="back-link">
          ← Back to login
        </Link>
        <h1 className="auth-title">Reset your password</h1>
        <p className="auth-subtitle">
          We'll send a one-time code to help you reset your password
        </p>

        <div className="tab-switcher">
          <button
            type="button"
            className={`tab-btn ${method === 'email' ? 'active' : ''}`}
            onClick={() => setMethod('email')}
          >
            Email
          </button>
          <button
            type="button"
            className={`tab-btn ${method === 'phone' ? 'active' : ''}`}
            onClick={() => setMethod('phone')}
          >
            Phone
          </button>
        </div>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              {method === 'email' ? 'Email address' : 'Phone number'}
            </label>
            <input
              className="form-input"
              type={method === 'email' ? 'email' : 'tel'}
              placeholder={method === 'email' ? 'you@example.com' : '+1 555 000 0000'}
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-primary">
            Send OTP
          </button>
        </form>

        <div className="auth-links">
          Remembered your password? <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
